<script>
export default {
  name: "setPersonnel",
  data: function() {
    const generateData = _ => {
      const data = [];
      const cities = ['上海', '北京', '广州', '深圳', '南京', '西安', '成都'];
      const pinyin = ['shanghai', 'beijing', 'guangzhou', 'shenzhen', 'nanjing', 'xian', 'chengdu'];
      cities.forEach((city, index) => {
        data.push({
          label: city,
          key: index,
          pinyin: pinyin[index]
        });
      });
      return data;
    };
    return {
      data: generateData(),
      value: []
    };
  },
  methods: {
    filterMethod(query, item) {
      return item.pinyin.indexOf(query) > -1;
    }
  }
};
</script>

<template>
  <div class="setPersonnel">
    <el-transfer
      v-model="value"
      :data="data"
      filterable
      :titles="['请选择人员姓名', '销售总监名单']"
      :filter-method="filterMethod"
      filter-placeholder="请输入员工姓名"
    >
    </el-transfer>
  </div>
</template>

<style scoped lang="scss"></style>
